'use strict';

var $ = require('jquery');
window.jQuery = $; //windows.Jquery creates a global $ intance
// Do not require('gwwp'): the plugin entry only pulls in legacy
// gwwp-cookie.js (document.cookie = gwwp_cookie_consent), which Cookiebot
// auto-blocking classifies as marketing and then disables this whole UI
// bundle until marketing consent is given (VEROSUPP-1).
require('./detail-box');
require('./frontpage');
require('./libs/jquery.rcrumbs.min.js'); //responsive breadcrumbs
require('./header.js');
require('./viewpoint.js'); 
require('./case.js'); 
require('./frontpage.js'); 
require('./svg4everybody.js'); 
require('./libs/iframeResizer.min.js');
require('./iframe-resizer.js');


$(function() {

});
